import { BaseService, GET, Path, Query, QueryArrayFormat, QueryMap, Signal } from 'ts-retrofit3';

import type { InoResponse } from '@/Module/Core/Model/ApiModel';
import { InoHttpService } from '@/Module/Core/Service';
import { GRADE_API } from '@/Module/Grade/Constant';
import type {
  IGetGradeLevelInfoResponse,
  IGetStrategyLevelInfoRequest,
  IGetStrategyLevelInfoResponse,
  IGetUniqueUrlJsonRequest,
  IGetUniqueUrlJsonResponse,
} from '@/Module/Grade/Model/ApiModel';
import type { ILevel } from '@/Module/Grade/Model/DataModel';
import type { StrategyLevelQueryType } from '@/Module/Grade/Model/Enum';

class GradeService extends BaseService {
  @GET(GRADE_API.GET_UNIQUE_URL_JSON)
  async getUniqueUrlJson(
    @QueryMap _query: IGetUniqueUrlJsonRequest,
    @Signal _signal?: AbortSignal,
  ): Promise<InoResponse<IGetUniqueUrlJsonResponse>> {
    return <InoResponse>{};
  }

  @GET(GRADE_API.GET_STRATEGY_LEVEL_INFO)
  async getStrategyLevelInfo(
    @QueryMap _query: IGetStrategyLevelInfoRequest,
    @Signal _signal?: AbortSignal,
  ): Promise<InoResponse<IGetStrategyLevelInfoResponse[]>> {
    return <InoResponse>{};
  }

  @GET(GRADE_API.GET_STRATEGY_LEVEL_INFO)
  @QueryArrayFormat('repeat')
  async getGradeLevelInfo(
    @QueryMap _query: IGetStrategyLevelInfoRequest,
    @Signal _signal?: AbortSignal,
  ): Promise<InoResponse<IGetGradeLevelInfoResponse[]>> {
    return <InoResponse>{};
  }

  @GET(GRADE_API.GET_STRATEGY_LEVEL_INFO_BY_ID)
  async getGradeInfoById(
    @Path('id') _levelId: ILevel['id'],
    @Query('Includes') _includes: StrategyLevelQueryType,
    @Signal _signal?: AbortSignal,
  ): Promise<InoResponse<IGetGradeLevelInfoResponse>> {
    return <InoResponse>{};
  }
}

export default InoHttpService.build(GradeService);
